var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Photo",

    getDefaultProps () {
        return {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>photo</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="photo" fill="currentColor">
      <path d="M4.5,5.375 C4.017,5.375 3.625,4.983 3.625,4.5 C3.625,4.017 4.017,3.625 4.5,3.625 C4.983,3.625 5.375,4.017 5.375,4.5 C5.375,4.983 4.983,5.375 4.5,5.375 L4.5,5.375 Z M4.5,2.75 C3.5335625,2.75 2.75,3.5335625 2.75,4.5 C2.75,5.4664375 3.5335625,6.25 4.5,6.25 C5.4664375,6.25 6.25,5.4664375 6.25,4.5 C6.25,3.5335625 5.4664375,2.75 4.5,2.75 L4.5,2.75 Z M14.125,8.4935 L11.5,5.8125 L7.1508125,10.2360625 L5.375,8.4375 L1.875,11.6474375 L1.875,2.75 C1.875,2.267 2.267,1.875 2.75,1.875 L13.25,1.875 C13.733,1.875 14.125,2.267 14.125,2.75 L14.125,8.4935 L14.125,8.4935 Z M14.125,13.25 C14.125,13.733 13.733,14.125 13.25,14.125 L10.989,14.125 L7.7655,10.8590625 L11.5,7.1245625 L14.125,9.7495625 L14.125,13.25 L14.125,13.25 Z M2.75,14.125 C2.267,14.125 1.875,13.733 1.875,13.25 L1.875,12.8391875 L5.3509375,9.7259375 L9.7504375,14.125 L2.75,14.125 L2.75,14.125 Z M13.25,1 L2.75,1 C1.7835625,1 1,1.7835625 1,2.75 L1,13.25 C1,14.2164375 1.7835625,15 2.75,15 L13.25,15 C14.2164375,15 15,14.2164375 15,13.25 L15,2.75 C15,1.7835625 14.2164375,1 13.25,1 L13.25,1 Z" id="Fill-217"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/photo.svg
 **/